import { formatMoney } from '../../utils/currency';

let theme = window.theme || {};

export default (parent, selectors, product_json) => {
  const form = parent.querySelector('form');
  const selected_variant_id = Number(form.querySelector('input[name="id"]').value);
  const selected_variant_data = product_json.variants.find(
    (v) => v.option1 === selectors.color.value && v.option2 === selectors.size.value,
  );
  let selected_variant;
  let price;
  let compare_price;

  if (selected_variant_id) {
    selected_variant = product_json.variants.find((v) => v.id === selected_variant_id);
  } else {
    selected_variant = selected_variant_data.id;
  }
  if (!selected_variant) {
    return;
  }
  if (selected_variant_id) {
    price = selected_variant.price;
    compare_price = selected_variant.compare_at_price;
  } else {
    price = selected_variant_data.price;
    compare_price = selected_variant_data.compare_at_price;
  }

  selectors.price.textContent = formatMoney(price, theme.moneyFormat);

  selectors.priceContainer.classList.remove('ShoppableImage__ProductPrice--Sale');
  selectors.compareAt.textContent = '';
  if (compare_price > price) {
    selectors.priceContainer.classList.add('ShoppableImage__ProductPrice--Sale');
    selectors.compareAt.textContent = formatMoney(compare_price, theme.moneyFormat);
  }
};
